import { ICard } from '../model/types/card';
import { useAppAxios } from '/shared/api/axios';
import { TemplateResponse, ErrorResponse } from '/shared/api/type';

export function useGetCard(link: string) {
  return useAppAxios<TemplateResponse<ICard>, null, ErrorResponse>(`/marker/` + link);
}
